var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M443.054,38.954h-49.336V15c0-8.284-6.716-15-15-15H68.946c-8.284,0-15,6.716-15,15v421.631c0,8.284,6.716,15,15,15    h31.353V497c0,8.284,6.716,15,15,15h327.755c8.284,0,15-6.716,15-15V53.954C458.054,45.67,451.338,38.954,443.054,38.954z     M83.946,421.631V30h279.771v391.631H83.946z M428.054,482H130.299v-30.369h248.419c8.284,0,15-6.716,15-15V68.954h34.336V482z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M194.01,124.538c-4.488-6.963-13.769-8.973-20.734-4.483l-27.295,17.591l-1.697-2.62    c-4.502-6.953-13.791-8.938-20.744-4.436c-6.953,4.504-8.939,13.791-4.436,20.744l9.833,15.182    c2.871,4.433,7.688,6.848,12.604,6.848c2.783,0,5.6-0.774,8.112-2.394l39.875-25.698    C196.491,140.785,198.498,131.501,194.01,124.538z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M194.01,190.254c-4.487-6.963-13.769-8.971-20.734-4.483l-27.295,17.59l-1.697-2.62    c-4.502-6.953-13.791-8.938-20.744-4.436c-6.953,4.504-8.939,13.791-4.436,20.744l9.833,15.182    c2.871,4.433,7.688,6.848,12.604,6.848c2.783,0,5.599-0.774,8.112-2.394l39.875-25.697    C196.491,206.501,198.498,197.217,194.01,190.254z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M315.97,134.942h-76.586c-8.284,0-15,6.716-15,15s6.716,15,15,15h76.586c8.284,0,15-6.716,15-15    S324.254,134.942,315.97,134.942z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M315.97,203.751h-76.586c-8.284,0-15,6.716-15,15s6.716,15,15,15h76.586c8.284,0,15-6.716,15-15    S324.254,203.751,315.97,203.751z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M315.97,272.56h-76.586c-8.284,0-15,6.716-15,15s6.716,15,15,15h76.586c8.284,0,15-6.716,15-15    S324.254,272.56,315.97,272.56z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M175.424,287.56l4.122-4.122c5.859-5.857,5.859-15.355,0.001-21.212c-5.857-5.857-15.355-5.857-21.213,0l-4.122,4.122    l-4.122-4.122c-5.857-5.857-15.355-5.857-21.213,0c-5.858,5.857-5.858,15.355,0,21.213L133,287.56l-4.122,4.122    c-5.858,5.857-5.858,15.355,0,21.213c2.929,2.929,6.768,4.394,10.606,4.394s7.678-1.465,10.606-4.394l4.122-4.122l4.122,4.122    c2.929,2.929,6.768,4.394,10.606,4.394s7.678-1.465,10.606-4.394c5.858-5.857,5.858-15.355,0-21.213L175.424,287.56z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckList);
export default __webpack_public_path__ + "static/media/check-list.db253ffaaccc74fb33929b4168bab89b.svg";
export { ForwardRef as ReactComponent };